module.exports = __webpack_public_path__ + "static/media/rescinded.83558a8b.jpeg";